import { checkTokenStatus } from '@src/common/api';

type goToCCCVRoutingType = 'location' | 'open';

interface IGoToCCCVParams {
  queryStringObject: any;
  routingType: goToCCCVRoutingType;
}
export const goToCCCV = async ({
  queryStringObject,
  routingType,
}: IGoToCCCVParams) => {
  const _queryStringObject = {
    service: 'lotteopen',
    ...queryStringObject,
  };
  const _URL = new URL(`${process.env.REACT_APP_CCCV_URL}/ext`);
  const _queryStringURLSearchParams = new URLSearchParams();

  Object.keys(_queryStringObject).forEach((item) => {
    _queryStringURLSearchParams.append(item, _queryStringObject[item]);
  });

  _URL.search = _queryStringURLSearchParams.toString();

  try {
    const result = await checkTokenStatus();
    if (result.status !== 401) {
      if (routingType === 'location') {
        window.location.href = _URL.toString();
      } else {
        window.open(_URL.toString(), '_blank');
      }
    }
  } catch (err) {
    window.location.href = `${process.env.REACT_APP_CCCV_URL}/nft`;
  }
};
